/** @jsxImportSource @emotion/react */

import React from 'react';
import { IconCheckmark } from '../../assets/icons/icon-checkmark';
import { css } from '@emotion/react';

interface CheckboxProps {
    checked?: boolean;
    onChange: () => void;
    disabled?: boolean;
}

const containerStyles = css`
    width: 16px;
    min-width: 16px;
    height: 16px;
    margin-right: 8px;
    border: 2px solid #000;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: #fff;
    user-select: none;
`;

export const Checkbox = (props: CheckboxProps) => {
    const { checked = false, onChange, disabled } = props;

    const handleClick = () => {
        if (disabled) {
            return;
        }

        onChange?.();
    };

    return (
        <div css={containerStyles} onClick={handleClick}>
            {checked ? <IconCheckmark /> : null}
        </div>
    );
};
